import React, { useContext, useState } from 'react';
import './Navbar.css';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../Assets/logo.png';
import { ShopContext } from '../../Context/ShopContext';
import { FiShoppingCart, FiUser, FiMenu, FiX, FiLogOut, FiClipboard } from 'react-icons/fi';

const Navbar = () => {
  const [menu, setMenu] = useState("shop");
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user, logout, getTotalCartItems } = useContext(ShopContext);
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    setIsMobileMenuOpen(false);
    navigate('/');
  };

  return (
    <header className="navbar">
      <div className="navbar-container">
        {/* --- Logo --- */}
        <Link to="/" onClick={() => setMenu("shop")} className="navbar-logo">
          <img src={logo} alt="Madurai Special Logo" />
          <p>MADURAI SPECIAL</p>
        </Link>

        {/* --- Navigation Links (Desktop) --- */}
        <nav className="navbar-menu-desktop">
          <ul>
            <li className={menu === "shop" ? "active" : ""} onClick={() => setMenu("shop")}>
              <Link to="/">Shop</Link>
            </li>
            <li className={menu === "combos" ? "active" : ""} onClick={() => setMenu("combos")}>
              <Link to="/combos">Combos</Link>
            </li>
            {user && (
              <li className={menu === "myorders" ? "active" : ""} onClick={() => setMenu("myorders")}>
                <Link to="/myorders">My Orders</Link>
              </li>
            )}
          </ul>
        </nav>

        {/* --- Actions (Login, Profile, Cart, Mobile Toggle) --- */}
        <div className="navbar-actions">
          {user ? (
            <>
              <Link to="/profile" className="navbar-action-item profile-icon-desktop">
                <FiUser size={24} />
                <span className="navbar-action-text">Profile</span>
              </Link>

              <button onClick={handleLogout} className="navbar-action-item logout-icon-desktop">
                <FiLogOut size={24} />
                <span className="navbar-action-text">Logout</span>
              </button>
            </>
          ) : (
            <Link to="/login" className="navbar-action-button">Login</Link>
          )}

          <Link to="/cart" className="navbar-action-item">
            <FiShoppingCart size={24} />
            {getTotalCartItems() > 0 && (
              <div className="navbar-cart-count">{getTotalCartItems()}</div>
            )}
          </Link>

          {/* --- Mobile Menu Toggle --- */}
          <div
            className="navbar-mobile-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
          </div>
        </div>
      </div>

      {/* --- Mobile Menu Overlay --- */}
      {isMobileMenuOpen && (
        <nav className="navbar-menu-mobile">
          <ul>
            <li onClick={() => { setMenu("shop"); setIsMobileMenuOpen(false); }}>
              <Link to="/">Shop</Link>
            </li>
            <li onClick={() => { setMenu("combos"); setIsMobileMenuOpen(false); }}>
              <Link to="/combos">Combos</Link>
            </li>

            {user && (
              <>
                <hr className="mobile-menu-divider" />
                <li onClick={() => { setMenu("myorders"); setIsMobileMenuOpen(false); }}>
                  <Link to="/myorders"><FiClipboard /> My Orders</Link>
                </li>
                <li onClick={() => { setMenu("profile"); setIsMobileMenuOpen(false); }}>
                  <Link to="/profile"><FiUser /> Profile</Link>
                </li>
                <li className="mobile-logout" onClick={handleLogout}>
                  <FiLogOut /> Logout
                </li>
              </>
            )}
          </ul>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
